document.addEventListener('DOMContentLoaded', function() {
  const detailsMenu = document.getElementById('Details-menu-drawer-container');
  const header = document.querySelector('header');

  if (detailsMenu && header) {
    let overlay = document.createElement('div');
    overlay.id = 'menu-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = header.offsetHeight + 'px';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = 'calc(100% - ' + header.offsetHeight + 'px)';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    overlay.style.zIndex = '9998';
    overlay.style.display = 'none';

    detailsMenu.parentNode.insertBefore(overlay, detailsMenu);

    function toggleOverlay() {
      if (detailsMenu.open) {
        overlay.style.display = 'block';
        document.body.style.overflow = 'hidden'; // Prevents page scrolling
      } else {
        overlay.style.display = 'none';
        document.body.style.overflow = ''; // Restores page scrolling
      }
    }

    detailsMenu.addEventListener('toggle', toggleOverlay);

    // Initial check on page load
    toggleOverlay();

    // Close the menu ONLY when the close button is clicked
    const closeMenuButton = detailsMenu.querySelector('button[aria-label="Close"]');
    if (closeMenuButton) {
      closeMenuButton.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevents triggering any parent listeners
        detailsMenu.removeAttribute('open');
        toggleOverlay();
      });
    }
  }
});

/* Oct 11 2026 (Tommy): cart CHECKOUT buttons go straight to our Vitasource checkout,
   skipping the extra shop.app Shop Pay page. Shop Pay is still a button on our checkout. */
(function () {
  function fastCheckout(e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!b) return;
    var base = (window.routes && window.routes.cart_url) || '/cart';
    b.setAttribute('formaction', base + '?skip_shop_pay=true');
  }
  document.addEventListener('click', fastCheckout, true);
})();
